export function apiCall(method, url) {
    return async function call(body) {
        try {
            const newBody = typeof body === 'object' && body !== null ? JSON.stringify(body) : body;
            const response = await fetch(url, {
                method,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Version': process.env.RELEASE_VERSION ?? 'unknown',
                    'X-Url-Path': window.location.href,
                },
                body: newBody,
            });
            if (response.status === 200) {
                return await response.json();
            }
            if (response.status === 400) {
                // TODO: validate
                return await response.json();
            }
            if (response.status === 403) {
                // TODO: validate
                return await response.json();
            }
            return {
                status: 'network error',
                httpStatus: response.status,
                message: await response.text(),
            };
        }
        catch (error) {
            return {
                status: 'network error',
                httpStatus: 0,
                message: error instanceof Error ? error.message : String(error),
            };
        }
    };
}
//# sourceMappingURL=apiCall.js.map